export default "__VITE_ASSET__e3260f38__"